<div class="HS DialerTable long-header">
  <form [formGroup]="form" autocomplete="off" class="box weightageTable">
    <ng-container formArrayName="rows">
      <table mat-table [dataSource]="dataSource"
        matSort
        class="mat-elevation-z8 mat-table-custom">
        <ng-container matColumnDef="familyCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="familyCode"> Family code </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <p>{{element.familyCode}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="version"> Global Software Release </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <p>{{element.name}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="releaseDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="releaseDate"> Release UTC </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <div [innerHTML]="datePipe.transform(element.releaseDate,'yyyy-MM-dd')"></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <p>{{element.name}}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="environment">
          <th mat-header-cell *matHeaderCellDef style="width:16%" mat-sort-header="environment"> Mandatory - Region </th>
          <td mat-cell *matCellDef="let element; let i = index">
            @if (!element.onEdit || isTenantLevel()) {
              <p>
                {{formatEnvironmentValue(element.environmentValue)}}
              </p>
            }
            @if (element.onEdit && !isTenantLevel()) {
              <ng-select
                [items]="availableReleasesArray"
                bindLabel="version"
                bindValue="id"
                [clearable]="false"
                [clearOnBackspace]="false"
                [formControl]="getFormControl(element, 'environmentValue')">
              </ng-select>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="tenant">
          <th mat-header-cell *matHeaderCellDef style="width:16%" mat-sort-header="tenant"> Mandatory - Country </th>
          <td mat-cell *matCellDef="let element; let i = index">
            @if (!element.onEdit) {
              <p>
                {{formatTenantValue(element.tenantValue, element.environmentValue)}}
              </p>
            }
            @if (element.onEdit) {
              <ng-select
                [items]="availableReleasesArray"
                bindLabel="version"
                bindValue="id"
                [clearable]="false"
                [clearOnBackspace]="false"
                [formControl]="getFormControl(element, 'tenantValue')">
              </ng-select>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element; let i = index">
            @if (!element.onEdit) {
              <button mat-icon-button color="primary" matTooltip="Edit Row"
                (click)="onRowEditInit(element)">
                <mat-icon>edit</mat-icon>
              </button>
            }
            @if (element.onEdit) {
              <button mat-icon-button color="warn" matTooltip="Cancel Row"
                (click)="onRowEditCancel(element)">
                <mat-icon>rotate_left</mat-icon>
              </button>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="savefooter">
          <th mat-footer-cell *matFooterCellDef colspan="7" class="footer">
            <div class="OrangeButton">
              <button mat-raised-button type="submit" (click)="onSave()" [disabled]="!hasChanges()"
                [matTooltip]="hasChanges()? 'Save changes' : 'Save disabled'"
                class="button-color-fix pull-right">
                Save
                <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
              </button>
            </div>
          </th>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true">
        </tr>
                <tr mat-row *matRowDef="let element; let i = index;
                    columns: columnsToDisplay;" class="item" [class.alternative2]="element.onEdit">
        </tr>
        <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true">
        </tr>
      </table>
    </ng-container>
  </form>
</div>